import api from '@/lib/api'

export default {
  namespaced: true,
  state: {
    //results: []
    searchList: {
      searchList: [],
      searchListRowCount: 0,
    },
    searchCount: {},
  },
  mutations: {
    // setResults(state, results) {
    //   state.results = results;
    // }
    setSearchList(state, items) {
      state.searchList = items;
    },
    searchCount(state, items) {
      state.searchCount = items.data;
    },
  },
  actions: {
    async search({ commit }, { keyword, itemType, RowsPerPage, PageNumber}) {
      const response = await api.search(keyword, itemType, RowsPerPage, PageNumber);
      //console.log('response ::::::::::::: ', response);
      commit('setSearchList', {searchList: response.data.Result, searchListRowCount:  response.data.pageInfo ? response.data.pageInfo.RowCount : 0})
    },
    async searchCount({ commit }, {keyword}) {
      const response = await api.searchItemCount(keyword);
      //console.log('searchCount response ::::::::::::: ', response);
      commit('searchCount', response)
    }
  }
}
